import type { DisplayVariant } from "../Coverage";
import type { Upsell } from "../../types";
import { Upsells } from "../Upsells/Upsells";
import { Tag } from "../Tag";

export type UpsellContentProps = {
  upsells: Upsell[];
  additionalCoverage?: boolean;
  displayVariant: DisplayVariant;
};

export const UpsellContent = ({
  upsells,
  additionalCoverage = false,
  displayVariant,
}: UpsellContentProps) => {
  if (upsells.length > 0) {
    return <Upsells upsells={upsells} displayVariant={displayVariant} />;
  }

  if (additionalCoverage) {
    return <Tag text="Extra coverage available in the next steps" />;
  }
};
